import React from 'react';
import ReactDOM from 'react-dom';
import 'materialize-css/dist/css/materialize.min.css'
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as props from './properties';
import firebase from 'firebase';
import { Provider } from 'react-redux';
import store from './redux/store';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import MantenimientoGate from './components/mantenimientoGate';


firebase.initializeApp(props.FIREBASE_PROPS);

const db = firebase.firestore();

// Solución para problemas de conexión
db.settings({
  experimentalForceLongPolling: true,
  merge: true,
});


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Switch>
          <Route path="/" render={(routeProps) => (
            <MantenimientoGate>
              <App {...routeProps} />
            </MantenimientoGate>
          )} />
        </Switch>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
